import {Injectable} from "@angular/core";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../../../shared/redux-store/store";
import {isUndefined} from "util";

@Injectable()
export class HasPermissionToGuard {

  constructor(private ngRx: NgRedux<IAppState>) {
  }

  hasPermissionTo(permission: string) {
    return hasPermissionTo(this.ngRx, permission);
  }

}

export function hasPermissionTo(ngRx: NgRedux<IAppState>, permission: string): boolean {

  const user = ngRx.getState().session.user;

  if (!user) {
    return false;
  }

  return !isUndefined(user.permissions.find(p => p == permission));

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/authorization/guards/has-permission-to.guard.ts